<template>
  <div class="bg-white border-b border-gray-100 py-3 px-4 shadow-sm">
    <div
      class="container mx-auto flex flex-col lg:flex-row items-center justify-between gap-4"
    >
      <!-- Left Group: Order Type & Timing or Order Info -->
      <div
        v-if="showOrderTypeOptions || orderNumber || tableName"
        class="flex flex-row items-center gap-3 w-full lg:w-auto"
      >
        <!-- Order Info for table orders -->
        <div v-if="tableName || orderNumber" class="flex items-center gap-2">
          <div class="flex flex-col sm:flex-row sm:items-center sm:gap-2">
            <span
              v-if="tableName"
              class="text-lg sm:text-xl font-semibold text-gray-900"
            >
              Table {{ tableName }}
            </span>
            <span
              v-if="tableName && orderNumber"
              class="hidden sm:inline text-lg text-gray-400"
              aria-hidden="true"
            >
              -
            </span>
            <span
              v-if="orderNumber"
              class="text-lg sm:text-xl font-medium text-gray-700"
            >
              Order #{{ orderNumber }}
            </span>
          </div>
        </div>

        <!-- Order Type Toggle -->
        <template v-else>
          <OrderTypeToggle />
          <TimingTrigger />
        </template>
      </div>

      <SearchInput />
    </div>
  </div>
</template>

<script>
import OrderTypeToggle from "./OrderTypeToggle.vue";
import TimingTrigger from "./TimingTrigger.vue";
import SearchInput from "./SearchInput.vue";

export default {
  name: "OrderOptionsBar",
  components: {
    OrderTypeToggle,
    TimingTrigger,
    SearchInput
  },
  props: {
    showOrderTypeOptions: {
      type: Boolean,
      default: true
    },
    orderNumber: {
      type: [String, Number],
      default: null
    },
    tableName: {
      type: String,
      default: null
    }
  }
};
</script>
